/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social/facebook': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="#8300BF" fill-rule="nonzero"><path pid="0" d="M16 30c-7.729-.008-13.992-6.271-14-14C2.008 8.271 8.271 2.008 16 2c7.729.008 13.992 6.271 14 14-.008 7.729-6.271 13.992-14 14zm0-26C9.376 4.007 4.007 9.376 4 16c.007 6.624 5.376 11.993 12 12 6.624-.007 11.993-5.376 12-12-.007-6.624-5.376-11.993-12-12z"/><path pid="1" d="M20.704 7.557h-2.543a4.218 4.218 0 00-4.215 4.214v2.543h-2.543v3.415h2.543v6.76h3.415v-6.76h2.544l.871-3.415h-3.415v-2.47a.884.884 0 01.872-.872h2.471V7.557z"/></g>'
  }
})
